import React from 'react';

import Classes from './Skeleton.module.scss';

type TBlockSkeletonProps = {
  className: string;
};

const BlockSkeleton = ({ className }: TBlockSkeletonProps) => <div className={`${Classes.base} ${className}`} />;

export default BlockSkeleton;
